import { vehicleXinghao } from '@/api/index'

export function getVehicleXinghao (data) {
  return vehicleXinghao.request({
    method: 'post',
    url: '/GetVehicleXinghao',
    data
  })
}

export function uploadImg (data) {
  return vehicleXinghao.request({
    url: '/UploadImg',
    method: 'post',
    data,
    iSFromData: true
  })
}
